import React from 'react';
import classes from './about.css';
import example1 from './example1.gif';
import example2 from './example2.gif';
import example3 from './example3.gif';
import example4 from './example4.gif';
import { Aux, DemoBrowser } from '../../Components';

const About = () => {
  return (
    <Aux>
      <div
        className={classes.BackgroundContainer}
        style={{ height: document.body.scrollHeight }}
      >
        <div className={classes.Background} />
      </div>
      <div className={classes.Container}>
        <div className={classes.Banner}>
          <h2 className={classes.Tagline}>
            Virtual Math Teams (VMT) fournit un environnement collaboratif pour
            explorer le monde des mathématiques ...
          </h2>
        </div>
        <div className={classes.Content}>
          <DemoBrowser>
            <img src={example1} height={320} alt="example-1" />
          </DemoBrowser>
          <p className={classes.Description}>
            VMT uses{' '}
            <a
              className={classes.Link}
              href="https://www.geogebra.org/"
              rel="noopener noreferrer"
              target="_blank"
            >
              GeoGebra
            </a>{' '}
            et{' '}
            <a
              className={classes.Link}
              href="https://www.desmos.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Desmos
            </a>{' '}}
            en tant qu’espace de travail sous-jacent, vous avez instantanément
            accès à des millions d’activités créées par des enseignants et des
            passionnés de mathématiques du monde entier.
          </p>
        </div>
        <div className={classes.Content}>
          <p className={classes.Description}>
            Les enseignants peuvent gérer leurs classes et leurs programmes en
            créant des cours et des activités pouvant être réutilisées ...
          </p>
          <DemoBrowser>
            <img className={classes.Image} src={example2} alt="example-2" />
          </DemoBrowser>
        </div>
        <div className={classes.Content}>
          <DemoBrowser>
            <img src={example3} alt="example-3" />
          </DemoBrowser>
          <p className={classes.Description}>
            ... Ou quiconque peut commencer à collaborer immédiatement en
            invitant simplement un autre membre VMT dans sa salle
          </p>
        </div>
        <div className={classes.Content}>
          <p className={classes.Description}>
            ... Ou tout le monde peut commencer à collaborer immédiatement en
            invitant un autre membre VMT dans leur salle.
          </p>
          <DemoBrowser>
            <img src={example4} alt="example-4" />
          </DemoBrowser>
        </div>

        <div className={classes.Container2}>
          <div className={classes.Banner}>
            <h2 className={classes.Tagline2}>Notice</h2>
          </div>
        </div>
        <div className={classes.Content2}>
          <p className={classes.DescriptionTact}>
            L'équipe TACT, basée à l'Université Laval, s'intéresse aux logiciels
            de collaboration sous support Web depuis 1995. Elle fait partie de
            la communauté de recherche sur l'apprentissage collaboratif assisté
            par ordinateur (CSCL). VMT est l’un des logiciels qui a été mis au
            point par des chercheurs de cette communauté et il a démontré sa
            valeur grâce à plusieurs recherches. Le principal chercheur qui a
            mené différentes recherches sur l'efficacité de ce logiciel est
            Gerry Stahl.
            <br />
            <br />
            Plus spécifiquement, ce logiciel est redevable à la
            recherche-développement de logiciels Virtual Math Teams qui a débuté
            en 2003 à l’Université Drexel avec Gerry Stahl et The Math Forum
            (Steve Weimar, Annie Fetter et Tony Mantoan en particulier). Un
            certain nombre d’autres chercheurs ont travaillé avec eux au fil des
            ans, notamment Arthur Powell de l’Université Rutgers, qui poursuit
            ses études sur la préparation des enseignants à l’utilisation
            efficace de tels environnements. Voir
            <a
              className={classes.LinkExternal}
              href="http://gerrystahl.net/vmt/index.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://gerrystahl.net/vmt/index.html
            </a>
            pour de nombreux livres et articles issus de ce projet ainsi que les
            noms des nombreux autres chercheurs qui ont participé. Depuis 2015,
            le développement du logiciel VMT et les études connexes se sont
            poursuivis sous la direction de Steve Weimar et Annie Fetter qui
            font maintenant partie du Partenariat du 21ème siècle pour
            l’enseignement des STEM ({" "}
            <a
              className={classes.LinkExternal}
              href="http://21pstem.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://21pstem.org/
            </a>
            ). L’équipe de Weimar a travaillé à la réécriture du logiciel VMT
            (VMT-2 comme on l’appelle ici au Québec), lequel intègre les
            plates-formes mathématiques dynamiques que sont Desmos et GeoGebra.
            Il intègre aussi un tableau de bord pour les enseignants qui les
            aide à guider l’activité collaborative, développé par les chercheurs
            Kobi Gai et Baruch Schwartz en Israël.
            <br />
            <br />
            Les membres de l'équipe TACT qui ont traduit VMT, versions 1 et 2,
            sont les personnes suivantes : Christian Perreault, Doudou Camara,
            Molly Vézina, Jean-François Malaise, Étienne Ouellet et Simon
            Duguay. Pour joindre un membre de l'équipe :
            equipe.tact@fse.ulaval.ca.
            <br />
            <br />
          </p>
        </div>
        <div className={classes.Container3}>
          <div className={classes.Banner}>
            <h2 className={classes.Tagline2}>Notice</h2>
          </div>
        </div>
        <div className={classes.Content3}>
          <p className={classes.DescriptionTact}>
            The TACT team, based at Laval University, has been interested in web
            collaboration software since 1995 and is part of Computer-supported
            Collaborative Learning (CSCL) research community. One of the
            software developed and that has demonstrated its value through
            several searches is VMT. The researcher who has conducted several
            research projects on the effectiveness of this software is Gerry
            Stahl.
            <br />
            <br />
            This site is indebted to the Virtual Math Teams research and
            software development project which began in 2003 at Drexel
            University with Gerry Stahl and The Math Forum (Steve Weimar, Annie
            Fetter, and Tony Mantoan in particular). A number of other
            researchers have worked with them over the years including Arthur
            Powell, Rutgers University, who continues to work on studies of
            teacher preparation for using such environments effectively. See
            <a
              className={classes.LinkExternal}
              href="http://gerrystahl.net/vmt/index.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://gerrystahl.net/vmt/index.html
            </a>
            for many books and articles that have come out of this project along
            with names of the many other researchers who participated.
            Development of the VMT software and related studies have continued
            under the direction of Steve Weimar and Annie Fetter since 2015, now
            part of The 21st Century Partnership for STEM Education ({" "}
            <a
              className={classes.LinkExternal}
              href="http://21pstem.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://21pstem.org/
            </a>
            ). Weimar’s team has been working on a rewrite of the VMT (VMT-2 as
            we call it here in Quebec) software incorporating other dynamic math
            platforms such as Desmos in addition to GeoGebra, along with plans
            to integrate a teacher dashboard to monitor the collaborative
            activity, developed by researchers Kobi Gai and Baruch Schwartz in
            Israel.
            <br />
            <br />
            The members of the TACT team who have been adapting VMT are the
            following people: Christian Perreault, Doudou Camara, Molly Vézina,
            Jean-François Malaise, Étienne Ouellet, and Simon Duguay.
          </p>
        </div>
      </div>
    </Aux>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/Layout/About/About.js